const XIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <path
        d="M19.7803 15.6922L30.5563 3.0752H28.0022L18.648 14.03L11.1732 3.0752H2.55322L13.8549 19.6425L2.55322 32.8725H5.10728L14.9872 21.3026L22.8814 32.8725H31.5013L19.7803 15.6922ZM16.2834 19.7872L15.1383 18.1377L6.02674 5.01202H9.94934L17.3008 15.605L18.4458 17.2545L28.0044 31.0251H24.0818L16.2834 19.7872Z"
        fill="url(#paint0_linear_120_275)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_120_275"
          x1="31.1354"
          y1="2.89253"
          x2="1.4597"
          y2="35.4871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FEF94" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default XIcon;
